module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAUCAYAAACJfM0wAAABL0lEQVQ4T+3VTSuEURTA8d8gykuSlwWfgb2VpXwCWciCjWQjtsqSslIWVmTjJQuSlU9hZWkrSoRMY6I73UfTmGdGM2Yjp249955z//c8555zbgZrWEaz8vKAaVxG9TBOMZhi/4HdDPJoSjFKlo8wGSebWKpinw/gN7RFw6t4ULIv6O+xiOu4OISd6HHwLpHwPYIWZEvBnXip4k0l9S0GyoH7o4e1su/Q9zfA3XiqNQ5IQlHIipBGIX32sF0HNGydwTz2A7gh0lDwGBZwHEc9fzCOWRwGj0NBtOMdPXiug5wUSC6As2iNsP8C+epuHXj9hRh/624XyBWBwx08YhU3Rfewjl6Uts2J2IIL4JANaa9HcsYBpuJkAys/afRbmENasYSHIOTmSYSN4gxdFeDnn79BU7Tuu+FgAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/admin/fullScreen.png
// module id = vfgb
// module chunks = 2